import { useQuery } from '@tanstack/react-query'

import { graphql_call as graphql_admin_call } from '../../schemas/server_admin_query.ts'

import { query_admin_fund_transactions } from './fund_graphql.ts'
import { keys } from './keystore.ts'

export type FundAssetTransaction = {
  id: string
  executed_at: string
  price_per_share: number
  share_count: number
  side: string
  spv: string | null
  spv_share_class: string | null
  share_class: string | null
  fees: number | null
  total_price: number
  created_at: string
  updated_at: string
}

export type FundTransactionWithAsset = {
  id: string
  executed_at: string
  action: string
  dollars: number
  master_shares: number | null
  action_blockchain_tx: string | null
  action_external_tx: string | null
  action_external_type: string | null
  mint_blockchain_amount: number | null
  mint_blockchain_number: number | null
  user_wallet_address: string | null
  feeder_id: string | null
  fund_id: string
  created_at: string
  updated_at: string
  asset_transaction: FundAssetTransaction | null
}

export type FundTransactionsResponse = {
  transactions: {
    nodes: FundTransactionWithAsset[]
    total_count: number
  }
}

export function useAdminFundTransactions(
  fundId: string,
  limit: number = 20,
  // offset: number = 0,
  // enabled: boolean = true
) {
  return useQuery({
    queryKey: keys.admin_funds.transactions(fundId, { limit }).queryKey,
    queryFn: async (): Promise<FundTransactionsResponse | null> => {
      try {
        if (!fundId) return null
        const response = await graphql_admin_call({
          query: query_admin_fund_transactions,
          variables: { fund_id: fundId, limit, after: null },
        })
        if (!response) return null
        return response as FundTransactionsResponse
      } catch (error) {
        console.error('Error fetching fund transactions:', error)
        return null
      }
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes
    // enabled: Boolean(fundId) && enabled,
  })
}
